import { Base64 } from 'js-base64';

const base64ToString = Base64.decode;

export const getDecodedId = (value: string): string => {
  if (!value) {
    return '';
  }

  const decodedValue = base64ToString(value);

  if (!decodedValue.includes(':')) {
    return value;
  }

  return decodedValue.split(':')[1] || '';
};

const stringToBase64 = Base64.encode;

export const getEncodedId = (value: string): string => {
  if (!value) {
    return '';
  }

  return stringToBase64(value);
};
